/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _get from 'lodash/get'
import { analytics } from 'services/Analytics'
import { ROUTES } from 'constants/routes'
import { ALERTS } from 'constants/alerts'
import { SUBSCRIPTION_STATUS, SUBSCRIPTION_PLAN_TYPE } from 'constants/subscription'
import { withLocalization } from 'hocs/localization'
import { getPrintedDateLocal } from 'utils/date'
import { loading } from 'hocs/loading'
import { onChangeSubscriptionPlan, onGetSubscriptionsPlansForRenew } from 'redux-app/actionCreators/subscription'
import { createAlert } from 'redux-app/modules/alerts'
import { selectPlan } from 'redux-app/modules/subscriptions'
import { getSubscriptionStatus, getUserSubscription, isUserAbleToOpenProfile, getActivePlan } from 'redux-app/selectors/user'
import { getSubscriptionPlansForRenew } from 'redux-app/selectors/subscription'
import PlanRenewal from './PlanRenewal'

export default compose(
  withLocalization('profile.planRenew'),
  connect(
    (state) => {

      let subscriptionPlansForRenew = getSubscriptionPlansForRenew(state)

      return {
        activePlanId: _get(getUserSubscription(state), 'planId'),
        plans: subscriptionPlansForRenew?.sort((a, b) => a.price > b.price ? 1 : -1),
        subscriptionStatus: getSubscriptionStatus(state),
        isUserAbleToOpenProfile: isUserAbleToOpenProfile(state),
        currentUserPlanName: _get(getUserSubscription(state), 'planName'),
        currentUserPlanImageUri: _get(getUserSubscription(state), 'planImageUri'),
        contractExpirationDate: getPrintedDateLocal(_get(getUserSubscription(state), 'termsEndDate')),
      }
    },
    {
      onChangeSubscriptionPlan,
      onGetSubscriptionsPlansForRenew,
      createAlert,
      selectPlan,
    },
  ),
  withRouter,
  withHandlers({
    onShowTerms: ({ plans, selectPlan, history }) => planId => {
      const newPlan = plans.find(plan => plan.id === planId)
      selectPlan(newPlan.id)

      return history.push(ROUTES.profile.renewPlan.terms)
    },
    onSelectChangePlan: ({ history }) => () => {
      return history.push({ pathname: ROUTES.profile.enrollPlan.root, state: { changeAndRenew : true }})
    },
  }),
  lifecycle<any, any>({
    componentWillMount () {
      this.props.onGetSubscriptionsPlansForRenew()
        .then(() => {
          this.setState({
            loadProgress: 100,
          })
        })
        .catch(() => {
          this.setState({
            loadProgress: 100,
          })
        })
    },
  }),
  loading,
)(PlanRenewal)
